import useBaseApiHook, { BASE_API_CONSTANT } from "services/useBaseApiHook"

const REPO_URL = {
  getCau: "/dashboard/cau",
  getIfgSummary: "/dashboard/ifg/summary",
  getIfg: "/dashboard/ifg",
  getIfgDiv: "/dashboard/ifg/div",
  getIfgDept: "/dashboard/ifg/dept",
}

const useDashboardRepo = (initialLoading = false) => {
  const { isLoading, data, error, executeApi } = useBaseApiHook(initialLoading)

  const getCau = async (payload) => executeApi(REPO_URL.getCau, BASE_API_CONSTANT.METHOD.POST, payload)
  const getIfgSummary = async (payload) => executeApi(REPO_URL.getIfgSummary, BASE_API_CONSTANT.METHOD.POST, payload)
  const getIfg = async (payload) => executeApi(REPO_URL.getIfg, BASE_API_CONSTANT.METHOD.POST, payload)
  const getIfgDiv = async (payload) => executeApi(REPO_URL.getIfgDiv, BASE_API_CONSTANT.METHOD.POST, payload)
  const getIfgDept = async (payload) => executeApi(REPO_URL.getIfgDept, BASE_API_CONSTANT.METHOD.POST, payload)

  return {
    isLoading,
    data,
    error,
    getCau,
    getIfgSummary,
    getIfg,
    getIfgDiv,
    getIfgDept,
  }
}

export default useDashboardRepo
